import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c96vrxm17w: FaireBrandEntity = {
  token: "b_c96vrxm17w",
  type: "brand",
  name: "Lavender Thorne",
  avatarUrl:
    "https://cdn.faire.com/fastly/aa00295d95c1c59473f185ae676d86004ca56276f12cdfc91a800f86dcec8151.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f2e08b185b4cfbfd45987922a22b2670461c809b3e518c0b19cf0e09d87b0bd6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aa00295d95c1c59473f185ae676d86004ca56276f12cdfc91a800f86dcec8151.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f2e08b185b4cfbfd45987922a22b2670461c809b3e518c0b19cf0e09d87b0bd6.jpeg",
  location: "TX, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 132,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Lavender Thorne, where we hand-make natural products with care and love. Co-Founded by Cassidy Lavender, a pastor's wife and a mom of three boys, our brand is rooted in a passion for health and wellness. Inspired by a Bible study with friends, we create products with organic, therapeutic-grade, and 100% pure ingredients. We have products from home, body, hair, baby to overall natural remedies. Thank you for exploring our brand – we're here to answer any questions and welcome your feedback. May you be blessed abundantly!\n\n*Please feel free to leave us a 5-star review.  If our service was anything but outstanding, please contact us before leaving a negative review and we will do our best to make it right! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:30.919Z",
    importedBy: "entity-db-cli",
  },
};
